import { indexOf, without } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

class FlowListItemCheckbox extends Component {
  onCheckboxClick = () => {
    const { baseItem, checkboxItem } = this.props;
    this.props.onItemChange({
      ...baseItem,
      depends: this.toggleDependentItem(baseItem.depends, checkboxItem.id),
    });
  };

  toggleDependentItem = (dependentArr = [], itemId) => {
    if (indexOf(dependentArr, itemId) !== -1) {
      return without(dependentArr, itemId);
    }
    return [...dependentArr, itemId];
  };

  render() {
    const { baseItem, checkboxItem, disabled } = this.props;
    const depends = baseItem.depends || [];
    const { id, name } = checkboxItem;
    return (
      <div className="checkbox-container">
        <label htmlFor={name}>{name}</label>
        <br />
        <input
          type="checkbox"
          name={name}
          disabled={disabled}
          checked={depends.includes(id)}
          onChange={this.onCheckboxClick}
        />
      </div>
    );
  }
}

FlowListItemCheckbox.propTypes = {
  disabled: PropTypes.bool,
  baseItem: PropTypes.object,
  checkboxItem: PropTypes.object,
  onItemChange: PropTypes.func,
};

export default FlowListItemCheckbox;
